// A Files board in small, for its tile in All boards: the project folders down the side and the note it opens
// on, as the doc board's tile draws its pages. Only names: the folders as the computer last named them, and
// the last note open in this browser. No file's words are kept to draw it.

import type { Board, Entry } from "../../../shared/types";
import { titleOf } from "../../../shared/filelinks";
import { useStore } from "../../state/store";
import { readStoredJson } from "../../lib/stored";

/** One empty list, so a board with no computer linked reads the same one every time (a new [] each read looped). */
const NO_FOLDERS: never[] = [];

export function FilesThumb({ board }: { board: Board; entries: Entry[] }) {
  const folders = useStore((s) => s.runner?.folders ?? NO_FOLDERS);
  const v = readStoredJson<{ open?: unknown }>(`cb:files:${board.id}`, {});
  const open = typeof v.open === "string" ? v.open : null;
  return (
    <div className="ov-doc">
      <div className="ov-doc-side">
        {folders.slice(0, 8).map((f) => (
          <span key={f.path} className="ov-doc-row">
            {f.name}
          </span>
        ))}
      </div>
      <div className="ov-doc-page">
        <b>{open ? titleOf(open) : "Your project folders"}</b>
        <span />
        <span />
        <span className="is-short" />
      </div>
    </div>
  );
}
